import React from 'react';

export default function TitleComponent({titles, moveToPreviousView, activeView, userPolicyInput}) {
    return (
        <div className="w-full max-w-7xl mx-auto px-4 mt-12 mb-10">
            <div className="relative flex flex-col items-center text-center">
                
                {activeView !== 0 && (
                    <div className="absolute left-0 top-2 hidden md:block">
                        <button 
                            onClick={moveToPreviousView} 
                            className="btn btn-ghost rounded-full text-base-content/70 hover:text-base-content"
                        >
                            <i className="pi pi-arrow-left mr-2"></i> Back
                        </button>
                    </div>
                )}
                
                <div className="max-w-3xl mx-auto px-4 md:px-12">
                    {activeView !== 0 && (
                        <button 
                            onClick={moveToPreviousView} 
                            className="btn btn-sm btn-ghost rounded-full mb-4 md:hidden text-base-content/70"
                        >
                            <i className="pi pi-arrow-left mr-1"></i> Back
                        </button>
                    )}
                    <h1 className="text-4xl md:text-5xl font-black text-base-content tracking-tight mb-4">
                        {titles.topHeading}
                    </h1>
                    <p className="text-lg md:text-xl text-base-content/60 font-medium">
                        {titles.middleHeading}
                    </p>
                </div>
            </div>
            
            <div className="divider mt-10 mb-2 opacity-50"></div>
        </div>
    )
}